import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 border p-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, "What now?")
], -1)
const _hoisted_3 = { class: "col-lg-9" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Your product reviews", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "col-3" }
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ratings, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "row p-2"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: ($event: any) => (_ctx.clickToProduct(item.productId))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.getProductImageByBarcode(item.product.barcode),
                      alt: "product"
                    }, null, 8, _hoisted_8)
                  ], 8, _hoisted_7)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h3", null, _toDisplayString(item.productName), 1),
                  _createElementVNode("p", null, _toDisplayString(item.description), 1),
                  _createElementVNode("p", null, "Score: " + _toDisplayString(item.score), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: ($event: any) => (_ctx.clickToShopDelete(item.id))
                  }, " Delete ", 8, _hoisted_11)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}